import moment from 'moment'
let duracionLlamada = (start, end) => {

    let momentStart         = moment(start),
        momentEnd           = moment(end),
        diffSeconds         = momentEnd.diff(momentStart, 'seconds') % 60,
        diffMinutes         = momentEnd.diff(momentStart, 'minutes') % 60,
        diffHours           = momentEnd.diff(momentStart, 'hours') % 60;

    if(momentEnd.diff(momentStart, 'seconds') == 0){
        return '0 segundos'
    }

    console.log('diffSeconds', diffSeconds)
    console.log('diffMinutes', diffMinutes)
    console.log('diffHours', diffHours)

    // ROUNDING

    let diferenciaString = ''

    // HORAS
    if(diffHours && diffHours == 1){
        diferenciaString += '1 hora, '
    } else if (diffHours){
        diferenciaString += diffHours + ' horas, '
    }

    // MIN
    if(diffMinutes && diffMinutes == 1){
        diferenciaString += '1 minuto '
    } else if (diffMinutes){
        diferenciaString += diffHours + ' minutos '
    }

    // SECS
    if(diffMinutes && diffMinutes == 1){
        diferenciaString += ' con 1 segundo.'
    } else if (diffMinutes){
        diferenciaString += ' con ' + diffHours + ' segundos.'
    } else {
        diferenciaString += '.'
    }

    return diferenciaString
}
export {
    duracionLlamada
}